module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Regular.66316211e96e9bb7cfa38d5d70d92626.eot";